module.exports = __webpack_public_path__ + "static/4-438b38a2413e3b9acb816c7218a67aa4.jpg";